import React, { useContext } from "react";
// React Bootstrap
import { Accordion, Card, Button } from "react-bootstrap";
// Componentes
import VistaDescripcionProyecto from "../vistas/VistaDescripcionProyecto";
import FormDescripcionProyecto from "../formularios/FormDescripcionProyecto";
// Contexto
import { ModalContext } from "../../../../context/modalContext";

const DescripcionProyecto = ({ datosMisionProyecto, handlePutMisionProyecto }) => {
  // Contexto
  const { modalSetShow, modalSetTitle, modalSetContent } = useContext(ModalContext);
  return (
    <Accordion defaultActiveKey="0">
      <Card>
        <Card.Header>
          <Accordion.Toggle eventKey="0" as={Button} variant="link">
            Descripción
          </Accordion.Toggle>
          <Button
            variant="outline-primary"
            size="sm"
            className="float-right mr-4"
            onClick={() => {
              modalSetShow(true, "80%");
              modalSetTitle("Editar descripción del proyecto");
              modalSetContent(<FormDescripcionProyecto defaultValues={datosMisionProyecto} submissionHandler={handlePutMisionProyecto} />);
            }}
          >
            Editar
          </Button>
        </Card.Header>
        <Accordion.Collapse eventKey="0">
          <Card.Body className={"bg-light"}>
            <VistaDescripcionProyecto datosMisionProyecto={datosMisionProyecto} />
          </Card.Body>
        </Accordion.Collapse>
      </Card>
    </Accordion>
  );
};

export default DescripcionProyecto;
